import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { from, of } from 'rxjs';
import {
  concatMap,
  map,
  switchMap,
  withLatestFrom,
} from 'rxjs/operators';
import { SelectionDispositifActions } from '@features/demande-remboursement/dispositifs/store/actions/selection-dispositif.actions';
import { AppActions } from 'src/app/app.action';
import { selectIsStatutActif } from '@features/referentiel/features';
import { DialogService } from 'primeng/dynamicdialog';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { FolderActions } from '@features/dashboard/mon-stock/store/actions/folder.actions';
import { EDispositifUrl } from '@shared/constants';

@Injectable()
export class SelectionPaymentDispositifEffect {
  createDossier$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        SelectionDispositifActions.createDispositifRemboursement,
        AppActions.createDispositifRemboursement,
        FolderActions.createDispositifRemboursement
      ),
      concatMap((action) =>
        of(action).pipe(
          withLatestFrom(
            this.store.select(selectIsStatutActif)
          )
        )
      ),
      concatMap(([{ dispositif }]) => {
          const navigationMap = {
            AI: EDispositifUrl.AI,
            CP: EDispositifUrl.CP,
            PROA: EDispositifUrl.PROA,
            default: EDispositifUrl.OTHERS
          };
          const dispoitifUrl = navigationMap[dispositif.code as keyof typeof navigationMap] || navigationMap.default;
          
          return from(this.router.navigate([
            'demande-un-remboursement',
            'choix-organisme-formation',
            dispoitifUrl
          ]))
            .pipe(
              map(() => SelectionDispositifActions.noAction())
            );
      })
    )
  );

  // onDossierCreated$ = createEffect(
  //   () =>
  //     this.actions$.pipe(
  //       ofType(SelectionDispositifActions.createDossierSuccess),
  //       tap(({ dispositif, dossier }) => {
  //         const code =
  //           dispositif && dispositif.code ? dispositif.code.toLowerCase() : dispositif.code;
  //         this.router.navigate(
  //           ['demande-financement', dispositifUrl[code], dossier.nomDossier, 'create'],
  //           {
  //             state: { numero: dossier.nomDossier, id: dossier.identifiantTechnique },
  //           },
  //         );
  //       }),
  //     ),
  //   { dispatch: false },
  // );
  createOrResumeDispositifRemboursement$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(AppActions.createOrResumeDispositifRemboursement),
        switchMap(({ dispositif }) => {
          return of(AppActions.createDispositifRemboursement({ dispositif }));
        })
      );
    },
    { dispatch: true } 
   );
  

  constructor(
    private router: Router,
    private actions$: Actions,
    private store: Store,
    private dialogService: DialogService,
    private translate: TranslateService, 
  ) {}
}
